import { sharedStyles } from '../styles/shared-styles';
import { LitEntity, renderIf, css, html } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import '../common/bn-action';
import '../common/bn-dynamically-imported';
import '../common/bn-surface';
import '../work-orders/actions/request-removal-button';
import '../work-orders/actions/request-service-button';
import '../work-orders/parts/work-order-list';
import './parts/device-events-list';
import './actions/device-actions';
import './parts/device-details';
import './parts/device-overview';

class DeviceShow extends IndexMixin(LitEntity) {
  static get properties() {
    return {
      hidetitle: { type: Boolean },
      workOrdersHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px;
      }
      .center {
        margin-bottom: 0;
        margin-top: 1em;
        text-align: center;
      }
      work-order-list {
        margin-bottom: 1em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return;
    }

    const views = this.getViews();

    return html`
      <div class='header'>
        ${renderIf(!this.hidetitle, html`
          <h1>Device</h1>
        `)}
        <div class="actions">
          <request-service-button .href="${this.workOrdersHref}"></request-service-button>
          <request-removal-button .href="${this.workOrdersHref}" @response="${this._reload}"></request-removal-button>
        </div>
      </div>

      <bn-tabs>
        ${views.map((view) => html`
          <bn-tab
            ?active="${this.currentView ? view.name === this.currentView : view.default}"
            .href="/devices/show/${view.name}?deviceId=${encodeURIComponent(this.href)}"
          >${view.title}</bn-tab>
        `)}
      </bn-tabs>

      ${super.render()}
    `;
  }

  getViews() {
    const views = [
      {
        default: true,
        name: 'overview',
        title: 'Overview',
        render: () => {
          return html`
            <device-overview .href="${this.href}"></device-overview>
          `;
        },
      },
      {
        name: 'actions',
        title: 'Actions',
        render: () => {
          return html`
            <device-actions .href="${this.href}"></device-actions>
          `;
        },
      },
      {
        name: 'events',
        title: 'Events',
        render: () => {
          return html`
            <bn-surface>
              <device-events-list .href="${this.href}"></device-events-list>
            </bn-surface>
          `;
        },
      },
    ];

    if (this.workOrdersHref) {
      views.push({
        name: 'work-orders',
        title: 'Work Orders',
        render: () => {
          return html`
            <work-order-list .href="${this.workOrdersHref}" historical></work-order-list>
          `;
        },
      });
    }

    return views;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders');
  }
}

window.customElements.define('device-show', DeviceShow);
